export enum OrderType {
  NORMAL = 'NORMAL',
  RESERVE = 'RESERVE',
  PRE_SALE = 'PRE_SALE',
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/enums/order-type.enum.ts